module.exports = __webpack_public_path__ + "assets/img/1312389b5a71869d0994e58be626db4b.png";